import {inject, Injectable} from '@angular/core';
import {MainHttpService} from "./main-http.service";
import {firstValueFrom} from "rxjs";
import {IAgreementInfo} from "../api-types/dashboard.types";
import {
  InfoCalcRequest,
  InfoRateDetailResponse,
  TransactionCalcRequest,
  TransactionCalcResponse
} from "../api-types/exchange.types";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  #http = inject(MainHttpService);

  async infoAgreement(): Promise<IAgreementInfo> {
    const response$ = this.#http.get<IAgreementInfo>('info/agreement');
    return firstValueFrom(response$);
  }

  async calculator(data: TransactionCalcRequest): Promise<TransactionCalcResponse> {
    const response$ = this.#http.post<TransactionCalcResponse, TransactionCalcRequest>('trans/calc', data);
    return firstValueFrom(response$);
  }

  async infoCalc(data: InfoCalcRequest): Promise<TransactionCalcResponse> {
    const response$ = this.#http.post<TransactionCalcResponse, InfoCalcRequest>('info/calc', data);
    return firstValueFrom(response$);
  }

  async getRates(): Promise<any> {
    const response$ = this.#http.get<any>('info/rate');
    return firstValueFrom(response$);
  }

  async getQrData(): Promise<any> {
    const response$ = this.#http.get<any>('info/qr/data');
    return firstValueFrom(response$);
  }

  async rateDetail(): Promise<InfoRateDetailResponse> {
    const response$ = this.#http.get<InfoRateDetailResponse>('info/rate/detail');
    return firstValueFrom(response$);
  }
}
